<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelNonConformite popup="popup" [model]="menuContextuelNonConformite"></p-menu>

<div class="grid">
    <div class="col-12">
        <p-card>
            <p-table #dt [value]="actionscorrectives" [columns]="colonnesSelectionnees"
                [loading]="!EstCharge()" autoLayout="true" rowhover
                [globalFilterFields]="['numero', 'date', 'demandeur', 'nonConformite']" dataKey="id"
                [totalRecords]="actionscorrectives?.length"
                [sortField]="tableParams.getValue().sortField"
                [sortOrder]="tableParams.getValue().sortOrder"
                (onFilter)="tableParams.setValue(dt)" 
                (onSort)="tableParams.setValue(dt)" 
                (onPage)="tableParams.setValue(dt)">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <div class="flex flex-wrap gap-2">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" [(ngModel)]="globalFilter" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Search..." />
                            </span>
                            <button pButton pRipple icon="pi pi-plus"
                                class="p-button-success" label="Ajouter"
                                (click)="newActionCorrective()"></button>
                            <button pButton class="p-button-outlined"
                                icon="pi pi-filter-slash" (click)="clearFilters(dt)"></button>
                        </div>
                        <h5 class="titreTableau m-0">Actions Correctives</h5>
                        <div>
                            <app-selecteur-colonnes
                                [colonnesDisponibles]="colonnesDisponibles"
                                [(ngModel)]="selectedColumns"
                                (onChange)="surChangementColonnes($event)"
                                (onReset)="reinitialiserColonnesSelectionnees()">
                            </app-selecteur-colonnes>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="EstColonneSelectionnee('numero')" pSortableColumn="numero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="numero"></p-sortIcon>
                                <p-columnFilter type="text" field="numero" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('statut')" pSortableColumn="statut">
                            <div class="flex justify-content-between align-items-center">
                                Statut
                                <p-sortIcon field="statut"></p-sortIcon>
                                <p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
                                    [showOperator]="false" [showAddButton]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                            (onChange)="filter($event.value)" optionLabel="name">
                                            <ng-template let-option pTemplate="item">
                                                <div class="multiselect-representative-option">
                                                    <span class="ml-1">{{option.nom}}</span>
                                                </div>
                                            </ng-template>
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('date')" pSortableColumn="date">
                            <div class="flex justify-content-between align-items-center">
                                Date
                                <p-sortIcon field="date"></p-sortIcon>
                                <p-columnFilter type="date" field="date" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('demandeur')" pSortableColumn="demandeur">
                            <div class="flex justify-content-between align-items-center">
                                Demandeur
                                <p-sortIcon field="demandeur"></p-sortIcon>
                                <p-columnFilter type="text" field="demandeur" display="menu" class="ml-auto" />
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('nonConformite')" pSortableColumn="nonConformite">
                            <div class="flex justify-content-between align-items-center">
                                NC
                                <p-sortIcon field="nonConformite.numero"></p-sortIcon>
                                <p-columnFilter type="text" field="nonConformite.numero" display="menu"
                                    class="ml-auto" />
                            </div>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-actionCorrective>
                    <tr>
                        <td *ngIf="EstColonneSelectionnee('numero')">
                            <a
                                [routerLink]="'/assurancequalite/actioncorrective/' + actionCorrective.actionCorrectiveId">{{actionCorrective.numero}}</a>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('statut')"><span [class]="'statut ' + actionCorrective.statut.nom.toLowerCase()">
                                {{actionCorrective.statut.nom}}
                            </span>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('date')">{{actionCorrective.date | date: 'dd/MM/yyyy'}}</td>
                        <td *ngIf="EstColonneSelectionnee('demandeur')"><app-employe-avec-emplacement [employe]="actionCorrective.demandeur"></app-employe-avec-emplacement></td>
                        <td *ngIf="EstColonneSelectionnee('nonConformite')">
                            <p-button
                                [routerLink]="'/assurancequalite/nonconformite/' + actionCorrective.nonConformite.idNonConformite"
                                [label]="actionCorrective.nonConformite.numero" [text]="true"
                                pTooltip="Voir la non-conformité associée" tooltipPosition="bottom"
                                showDelay="750" [style]="{'height': '20px'}"></p-button>
                        </td>
                        <td class="celluleTableau">
                            <div class="flex justify-content-end">
                                <p-button pRipple icon="pi pi-eye" severity="success" styleClass="mr-2 boutonGrille"
                                    [routerLink]="'/assurancequalite/actioncorrective/' + actionCorrective.actionCorrectiveId" />
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>